'use strict';

function reserve($target, $source) {
    var height = Math.ceil($source.outerHeight());
    if (height > 0) {
        if (!$target.hasClass('js-unlimitail-reserved')) {
            $target.data('unlimitail-reserved-style', $target.get(0).style.minHeight);
        }
        $target.data('unlimitail-reserved-width', window.innerWidth);
        $target.css('min-height', height + 'px').addClass('js-unlimitail-reserved');
    }
}

function release($target) {
    if (!$target.hasClass('js-unlimitail-reserved')) {
        return;
    }
    $target.css('min-height', $target.data('unlimitail-reserved-style'));
    $target.removeClass('js-unlimitail-reserved');
    $target.removeData('unlimitail-reserved-style unlimitail-reserved-width');
}

function settle($target) {
    // Allow synchronous slider initialization and header relocation to finish first.
    window.requestAnimationFrame(function () {
        var $images = $target.find('img').filter(function () {
            // Offscreen lazy images must not retain blank space indefinitely.
            return !this.complete && this.loading !== 'lazy';
        });
        var remaining = $images.length;
        function finish() {
            window.requestAnimationFrame(function () {
                release($target);
            });
        }
        if (!remaining) {
            finish();
            return;
        }
        $images.each(function () {
            var image = this;
            function done() {
                $(image).off('load.unlimitailSkeleton error.unlimitailSkeleton', done);
                remaining--;
                if (!remaining) {
                    finish();
                }
            }
            $(image).one('load.unlimitailSkeleton error.unlimitailSkeleton', done);
            if (image.complete) {
                done();
            }
        });
    });
}

function replace($target, html) {
    var $component;
    if ($.trim(html || '') && $target.find('.cc-unlimitail-seo').length) {
        $component = $target.closest('.js-unlimitail-component');
        if ($component.length) {
            reserve($component, $component);
        }
        reserve($target, $target);
    }
    $target.html(html || '');
    if ($.trim(html || '')) {
        settle($target);
        if ($component && $component.length) {
            settle($component);
        }
    }
}

$(window).on('resize.unlimitailSkeleton', function () {
    $('.js-unlimitail-reserved').each(function () {
        var $target = $(this);
        if ($target.data('unlimitail-reserved-width') !== window.innerWidth) {
            release($target);
        }
    });
});

module.exports = { reserve: reserve, settle: settle, replace: replace };
